import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';
import { StyleColor, navBarHeight } from '../../utils/styles-constants';
import { spin, hexToRgba } from '../../utils/style';
import { Input, inputBoxHeight } from '../Form/styles';
import { MediaQueryStyleConfig, mediaQueryStyleConfigs, defaultStyle } from './constants';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';

export const ResourceCreationContent = styled('form')`
	width: 100%;
	max-width: 450px;
	margin: 0 5px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const getMediaQueries = (inputBoxNumber: number): string => {
	let mediaQueries = '';

	for (let i = 1; i < mediaQueryStyleConfigs.length; i++) {
		const mediaQueryConditionConfig = mediaQueryStyleConfigs[i - 1];
		const mediaQueryStyleConfig = mediaQueryStyleConfigs[i];

		if (mediaQueryStyleConfig) {
			mediaQueries += getMediaQuery(mediaQueryConditionConfig, mediaQueryStyleConfig, inputBoxNumber);
		}
	}

	return mediaQueries;
};

const getMediaQuery = (
	mediaQueryConditionConfig: MediaQueryStyleConfig,
	mediaQueryStyleConfig: MediaQueryStyleConfig,
	inputBoxNumber: number
): string => {
	return `
		@media ${getMediaQueryCondition(mediaQueryConditionConfig, inputBoxNumber)} {
			${getMediaQueryStyle(mediaQueryStyleConfig)}
		}
	`;
};

const getMediaQueryCondition = (mediaQueryStyleConfig: MediaQueryStyleConfig, inputBoxNumber: number): string => {
	const maxHeight = getMediaQueryConditionMaxHeight(mediaQueryStyleConfig, inputBoxNumber);
	return `only screen and (max-height: ${maxHeight}px)`;
};

const marginBetweenInputBoxes = 35;

const getMediaQueryConditionMaxHeight = ({
	marginTop,
	height,
// tslint:disable-next-line: align
}: MediaQueryStyleConfig, inputBoxNumber: number): number => {
	return parseInt(navBarHeight, 10)
		+ marginTop
		+ height
		+ inputBoxNumber * (inputBoxHeight + marginBetweenInputBoxes)
		+ (UserAgentUtils.isIOS() ? 2 * Utils.getKeyboardHeight() : 0);
};

const getMediaQueryStyle = ({
	marginTop,
	height,
}: MediaQueryStyleConfig): string => {
	return `
		margin-top: ${marginTop}px;
		height: ${height}px;
	`;
};

interface ResourceCreationIconProps {
	inputBoxNumber: number;
}

export const ResourceCreationIcon = styled('div')`
	${getMediaQueryStyle(defaultStyle)}

	& > svg {
		width: 100%;
		height: 100%;
	}

	${(props: ResourceCreationIconProps) => getMediaQueries(props.inputBoxNumber)}
`;

export const ResourceCreationInputWrapper = styled('div')`
	position: relative;
	width: 100%;
	margin-top: ${marginBetweenInputBoxes}px;
`;

interface ResourceCreationInputProps {
	value: string;
}

export const ResourceCreationInput = styled(Input)`
	box-sizing: border-box;
	width: 100%;
	border-radius: 6px;
	border: 1px solid ${StyleColor.Grey100};
	color: ${StyleColor.Black};
	font-size: 22px;
	text-align: center;

	${(props: ResourceCreationInputProps) => !!props.value && 'padding: 0 40px;'};
`;

const labelStyles = `
	position: absolute;
	bottom: calc(100% + 5px);
	left: 0;
	right: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	text-align: center;
`;

export const ResourceCreationInputLabel = styled('label')`
	${labelStyles}
	color: ${StyleColor.Black};
`;

export const ResourceCreationError = styled(Translate)`
	${labelStyles}
	color: ${StyleColor.Red};
`;

export const ResourceCreationInputClear = styled('button')`
	position: absolute;
	top: 15px;
	right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background-color: ${StyleColor.Grey300};
	outline: 0;
	cursor: pointer;

	svg {
		width: 7px;
		height: 7px;
		fill: ${StyleColor.White};
	}
`;

export const ResourceCreationLoader = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	font-size: 21px;
	color: ${StyleColor.White};
	background-color: ${hexToRgba(StyleColor.Black, 75)};

	svg {
		height: 35px;
		width: 35px;
		animation: ${spin};
		margin-right: 20px;
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceCreationPanel/styles.ts